import { UseMutationOptions } from '@tanstack/react-query';
import useAppMutation from 'hooks/useAppMutation';
import { BaseErrorResponse } from 'models/_base';
import API from 'services/API';
import { TemplateSettingsUpdatePayload } from 'models/automation/TemplateSettings';

type UpdateTemplateSettingsMutationArgs = TemplateSettingsUpdatePayload;

type ReactQueryMutationOptions = Omit<
  UseMutationOptions<{}, BaseErrorResponse, UpdateTemplateSettingsMutationArgs>,
  'mutationFn' | 'mutationKey'
>;

const updateSystemTemplate = ({
  ...payload
}: UpdateTemplateSettingsMutationArgs) => {
  return API.put<{}, BaseErrorResponse>(
    `/api/internal/automation/templates-settings`,
    payload,
  );
};

const useUpdateTemplateSettingsMutation = ({
  ...options
}: ReactQueryMutationOptions = {}) => {
  return useAppMutation({
    mutationFn: updateSystemTemplate,
    ...options,
  });
};

export default useUpdateTemplateSettingsMutation;
